export const ATTACHMENTS_PLACEMENTS = {
  MESSAGES: 'MESSAGES',
  FILES: 'FILES',
  TRANSPORT_DOCUMENTS: 'TRANSPORT_DOCUMENTS',
  MYACCOUNT_USER_DOCUMENTS: 'MYACCOUNT_USER_DOCUMENTS',
  ADDITIONAL_INFORMATION_DOCUMENTS: 'ADDITIONAL_INFORMATION_DOCUMENTS',
  FILE_ADDITIONAL_INFORMATION_DOCUMENTS:
    'FILE_ADDITIONAL_INFORMATION_DOCUMENTS',
};
